module.exports = __webpack_public_path__ + "static/media/locationGreen.0168242e.svg";